module.exports = {"230710002":"育林社区","230710003":"建林社区","230710004":"松林社区","230710005":"新林社区","230710006":"五星社区","230710400":"翠北林场","230710401":"前丰林场","230710402":"永丰经营所","230710403":"平原经营所","230710404":"丽丰经营所","230710405":"杨树河经营所","230710406":"平山经营所","230710407":"丽林经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230710.json
// module id = 749
// module chunks = 0